import { CreatedInterfaces } from 'interfaces';

import { usePostRequest } from 'hooks/utils/usePostRequest';

const resource = 'user-post';

const useCreateUser = () => {
  const [{ data, error, loading }, createUser] = usePostRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/users`, useRouteIssuer: true
  });

  return {
    user: data,
    createUser,
    isLoading: loading,
    isError: error,
  };
};

export default useCreateUser;
